export default __webpack_public_path__ + "static/media/key.76da8435.svg";